/**
 * Normalises legacy locally-stored tab edit payloads to the API contract (ADR section 7):
 * - LYRICS: `{ lyrics }` (early client bug) -> `{ content }`
 * - SCORE: `engine: "alphaTab@1.8.4"` -> `"1.8.4"` (API regex /^\d+\.\d+\.\d+$/)
 * Pure and idempotent; returns the input untouched when nothing needs changing.
 */
export function normalizeEditPayload(kind: string, payload: unknown): unknown {
  if (!payload || typeof payload !== 'object') return payload;
  const p = payload as Record<string, unknown>;
  if (kind === 'LYRICS' && 'lyrics' in p) {
    const rest = { ...p };
    const legacy = rest.lyrics;
    delete rest.lyrics;
    return { ...rest, content: typeof rest.content === 'string' ? rest.content : typeof legacy === 'string' ? legacy : '' };
  }
  if (kind === 'SCORE' && typeof p.engine === 'string' && !/^\d+\.\d+\.\d+$/.test(p.engine)) {
    const m = p.engine.match(/(\d+\.\d+\.\d+)/);
    const rest = { ...p };
    delete rest.engine;
    return m ? { ...rest, engine: m[1] } : rest;
  }
  return payload;
}
